import React from "react";
import Navigation from "../components/Navigation";
import Footer from "../components/Footer";
import EventsSection from "../components/EventsSection";

const EventsPage = () => {
  return (
    <div className="min-h-screen page-enter">
      {/* Hero Section with Mountain Pool Image */}
      <div className="relative min-h-screen flex flex-col justify-center items-center text-center px-6">
        {/* Background Image */}
        <div className="absolute inset-0 z-0 scale-in">
          <img 
            src="https://customer-assets.emergentagent.com/job_centered-nav/artifacts/u036rw4v_Mountain%20Pool.jpg"
            alt="Mountain pool winter retreat"
            className="w-full h-full object-cover"
          />
          <div className="absolute inset-0 bg-black/40"></div>
        </div>

        {/* Navigation */}
        <div className="absolute top-0 left-0 right-0 z-20 slide-in-top">
          <Navigation />
        </div>

        {/* Hero Content */}
        <div className="relative z-10 max-w-4xl">
          <h1 className="text-5xl md:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-2xl slide-in-bottom">
            Upcoming Events
          </h1>
          <p className="text-xl md:text-2xl text-white mb-8 max-w-3xl mx-auto leading-relaxed drop-shadow-xl stagger-1">
            Join us for exciting adventures and community-building experiences designed to create lasting memories and connections.
          </p>
        </div>
      </div>

      <div className="slide-in-bottom stagger-2">
        <EventsSection />
      </div>
      <Footer />
    </div>
  );
};

export default EventsPage;